import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { chain, LoadRealTimeInventory } from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { dispatchProductImpressions } from "@store/Services/AnalyticsService";
import setImpression from "@store/Store/Data/Analytics/Handlers/SetImpression";
import { getImpression } from "@store/Store/Data/Analytics/ImpressionsSelectors";
import { getIsCategoryPage, getIsSearchPage } from "@store/Store/Pages/ProductList/ProductListSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

replaceInChain(chain, LoadRealTimeInventory, props => {
    if (
        !props.productInfos ||
        props.productInfos.length === 0 ||
        (props.dataViewHasProducts && props.parameter.isShellEdit)
    ) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: props.productInfos.map(o => o.productId),
            expand: ["warehouses"], // Poolcorp Custom Code
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimeInventory",
                    id: props.parameter.id,
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimeInventory",
                    id: props.parameter.id,
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
});

addToEndOfChain(chain, async props => {
    if (props.products) {
        await waitFor(() => !!props.pricingLoaded);

        const state = props.getState();
        const currentPage = getCurrentPage(state);
        const isSearchPage = getIsSearchPage(state);
        const isCategoryPage = getIsCategoryPage(state);
        const isProductPage = currentPage.type === ProductDetailsPageContext;
        const currentCurency = state.context.session.currency?.currencyCode;

        const impressions = getImpression(state as StoreApplicationState);
        let currentPath = global?.location?.href || state.data.pages.location.pathname;
        if (isProductPage) {
            const productState = getProductState(state, state.pages.productDetails.selectedProductId);
            if (productState.value) {
                currentPath = productState.value?.canonicalUrl;
            } else {
                return;
            }
        }
        const matchingImpressions = impressions?.filter(impression => {
            return impression.pageUrl === currentPath;
        });

        const impressionAlreadyOccured = !!matchingImpressions?.length;

        if (impressionAlreadyOccured) {
            return;
        }

        let products: ProductContextModel[] | undefined;

        const {
            components: {
                productInfoLists: { productInfoListById },
            },
        } = state;

        const productInfoByProductId = productInfoListById[props.parameter.id]?.productInfoByProductId;

        if (props.products && productInfoByProductId) {
            products = props.products.map(product => {
                if (product) {
                    const productContext: ProductContextModel = {
                        product,
                        productInfo: (productInfoByProductId[product.id] as unknown) as ProductInfo,
                    };
                    return productContext;
                }
                return undefined;
            }) as ProductContextModel[];
        }

        dispatchProductImpressions(products, currentCurency, currentPage, isCategoryPage, isSearchPage, "");
        props.dispatch(setImpression({ pageUrl: currentPath, impressions: props.products }));
    }
});
